// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__15cJN","row":"styles_row__4rBZu"};